import IViewAction from "../../interface/dataStorage/view/IViewAction";
import IViewUnit from "../../interface/dataStorage/IViewUnit";
import IViewPermissions from "../../interface/dataStorage/view/IViewPermissions";
import _ from "underscore";
import IContentType from "../../interface/dataStorage/IContentType";
import IViewSchemaAction from "../../interface/dataStorage/view/IViewSchemaAction";

interface IRestViewUnitsService {
    getAllowedSchemeActions: (viewUnit: IViewUnit, permissions: IViewPermissions, contentType: IContentType) => IViewSchemaAction[]
    getAllowedDirectSchemeActions: (viewUnit: IViewUnit, permissions: IViewPermissions, contentType: IContentType) => IViewSchemaAction[]
    getAllowedCollectionActions: (viewUnit: IViewUnit, permissions: IViewPermissions, contentType: IContentType) => IViewAction[]
    getAllowedActions: <S extends IViewAction>(actions: S[], permissions: IViewPermissions, contentType: IContentType) => S[]
}

const ViewUnitsService: IRestViewUnitsService = {
    getAllowedSchemeActions: (viewUnit, permissions, contentType) => {
        return ViewUnitsService.getAllowedActions<IViewSchemaAction>(viewUnit.schemaActions, permissions, contentType).filter(a => !a.direct)
    },
    getAllowedDirectSchemeActions: (viewUnit, permissions, contentType) => {
        return ViewUnitsService.getAllowedActions<IViewSchemaAction>(viewUnit.schemaActions, permissions, contentType).filter(a => a.direct)
    },
    getAllowedCollectionActions: (viewUnit, permissions, contentType) => {
        return ViewUnitsService.getAllowedActions(viewUnit.collectionActions, permissions, contentType)
    },
    getAllowedActions: (actions, permissions, contentType)  => {
        return actions.filter(collectionAction => {
            const action = _.findWhere(contentType.actions, {uuid: collectionAction.action})
            return action && permissions[contentType.fullClassName] && permissions[contentType.fullClassName][action.name]
        })
    }
}

export default ViewUnitsService